<template>
    <div class="flex justify-center items-center 
        font-bold text-xl cursor-pointer 
        hover:bg-gray-200 transition-all duration-150 ease-in
        w-10 h-10 rounded-full ml-auto m-5"
    >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
        </svg>
    </div>
</template>

<script setup>
</script>
